import { cva, type VariantProps } from 'class-variance-authority';
import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

const iconBadgeVariants = cva(
  'flex shrink-0 items-center justify-center rounded-full [&>svg]:size-1/2',
  {
    variants: {
      tone: {
        brand: 'bg-brand-50 text-brand-600 ring-1 ring-brand-600/10',
        accent: 'bg-accent-100 text-accent-600 ring-1 ring-accent-500/15',
        success: 'bg-success-soft text-success ring-1 ring-success/15',
        danger: 'bg-danger-soft text-danger ring-1 ring-danger/15',
      },
      size: {
        md: 'size-12',
        lg: 'size-16',
        xl: 'size-20',
        '2xl': 'size-28',
      },
    },
    defaultVariants: { tone: 'brand', size: 'lg' },
  },
);

export type IconBadgeProps = VariantProps<typeof iconBadgeVariants> & {
  children: ReactNode;
  className?: string;
};

/** Icône mise en avant dans un rond coloré (en-tête d'écran, état vide, confirmation). */
export function IconBadge({ children, tone, size, className }: IconBadgeProps) {
  return (
    <span aria-hidden="true" className={cn(iconBadgeVariants({ tone, size }), className)}>
      {children}
    </span>
  );
}

export { iconBadgeVariants };
